import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientDetailNegotiateView のスタイル
 */
export const hotlineClientDetailNegotiateViewStyle = tv({
    slots: {
        base: [
            'flex flex-col gap-16',
            'py-32 px-16 md:px-32 mb-8',
            'lg:rounded-md',
        ],
        // 0件表示（期間内）
        noDataInPeriod: ['py-32 px-16', 'text-center'],
        // 0件表示（期間外）
        noDataOutPeriod: [
            'py-32 px-16',
            'flex flex-col items-center justify-center',
        ],
        noDataOutPeriodButtonWrap: ['flex flex-col lg:flex-row gap-16', 'mt-24'],
    },
});
